import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ITriggerAutopilotRunV1Response } from './trigger-autopilot-run-v1-response';
import { triggerAutopilotRunV1ResponseSchema } from './trigger-autopilot-run-v1-response';

export async function triggerAutopilotRunV1Api(): Promise<
  IValidatedResponse<ITriggerAutopilotRunV1Response>
> {
  return postRequest<ITriggerAutopilotRunV1Response>({
    path: '/sys/social/v1/autopilot/run',
    schema: triggerAutopilotRunV1ResponseSchema,
  });
}
